
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch,
} from 'vue';

interface IListSegments {
  name: string;
  code: number;
  checked: boolean;
}

export default defineComponent({
  components: {},

  props: {
    segmentsFilter: {
      type: Object as PropType<IListSegments[]>,
      default: () => ({}),
    },

    selectAll: {
      type: Array,
      default: () => [],
    },

    checkedAll: {
      type: Boolean,
      default: false,
    },

    labelFilter: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    const propsRef = ref(props);
    const selectedValue = ref(props.segmentsFilter);

    const filterSegment = computed(() => propsRef.value.segmentsFilter);

    watch(propsRef.value, (newValue) => {
      selectedValue.value = newValue.segmentsFilter;
      emit('filter-tag', selectedValue.value);

      if (newValue.segmentsFilter.every((el) => el.checked === true))
        allSegments.value = true;
      else allSegments.value = false;
    });

    onMounted(() => (selectedValue.value = filterSegment.value));

    const allSegments = ref(true);

    const changeAllSegments = () => {
      if (!allSegments.value) {
        selectedValue.value = props.segmentsFilter.map((el) => {
          return { ...el, checked: false };
        });
        // selectedValue.value.map((segment) => emit('value-selected', segment));
        emit('all-filter', { filterName: 'segment', checked: false });

        return;
      }
      selectedValue.value = props.segmentsFilter.map((el) => {
        return { ...el, checked: true };
      });
      // selectedValue.value.map((unit) => emit('value-selected', unit));
      emit('all-filter', { filterName: 'segment', checked: true });

      emit('filter-tag', selectedValue.value);
    };

    const changeFilter = (segment) => {
      emit('value-selected', segment);
      emit('filter-tag', selectedValue.value);

      if (selectedValue.value.every((el) => el.checked === true)) {
        allSegments.value = true;
        return;
      }
      allSegments.value = false;
    };

    const eventStop = (e) => {
      e.stopPropagation();
    };

    return {
      selectedValue,
      emit,
      filterSegment,
      changeFilter,
      eventStop,
      allSegments,
      changeAllSegments,
    };
  },
});
